export default __webpack_public_path__ + "static/media/contact--desktop.28862aab.webp";